import React from "react";
import { bind } from "decko";

import TagPropertyButton from "./TagPropertyButton";
import EditTagProperty from "./EditTagProperty";
import OptionPopoverBtn from "./OptionPopoverBtn";

function getPropOrder (prop) {
    switch (prop.name) {
        case "team": return 0;
        case "on target": return 1;
        case "shot type": return 2;
        case "shot result": return 2;
        case "scorer": return 3;
        case "player": return 4;
        default: return 10;
    }
}

export default class EditTag extends React.Component {
    constructor (props) {
        super(props);

        const tag = this.props.tag;
        let properties = this.props.prototypeProperties.map(property => ({
            name: property.name,
            type: property.type,
            id: property.name in tag ?
                tag[property.name].id : undefined,
            value: property.name in tag ?
                tag[property.name].value : undefined
        }));

        // Sort the list based on the most logical order to fill out the fields
        // F ex, we always want to set team first so we can filter out opponent players
        // And we want to set shot-type before scorer so we can tell if its an own goal etc
        properties.sort((a,b)=>getPropOrder(a)-getPropOrder(b));

        this.state = {
            editingPropertyIndex: 0,
            properties: properties,
            isOwnGoal: this.isOwnGoal(properties),
        };
    }

    @bind
    isOwnGoal (properties) {
        return properties.find(p=>p.value === "own goal") !== undefined;
    }

    @bind
    onChangeTag (action) {
        this.props.onChangeActive({
            action: action,
        });
    }

    @bind
    onChangePropertyValue (id, value) {
        let properties = this.state.properties.slice();
        let editedProperty = properties[this.state.editingPropertyIndex];

        if (editedProperty.type !== 'player' && editedProperty.type !== 'team') {
            id = undefined;
        }

        if (editedProperty.value === value) {
            //un-toggle
            value = undefined;
            id = undefined;
        }

        editedProperty["value"] = value;
        editedProperty["id"] = id;

        let newIndex = Math.min(properties.length-1, this.state.editingPropertyIndex+1);
        this.setState({
            editingPropertyIndex: newIndex,
            properties: properties,
            isOwnGoal: this.isOwnGoal(properties),
        });

        let tag = {action: this.props.tag.action};
        properties.filter((p) => p.value !== undefined).forEach((p) => {
            let prop = {
                type: p.type,
                value: p.value,
            };
            if (p.id !== undefined) {
                prop.id = p.id;
            }
            tag[p.name] = prop;
        });

        this.props.onMutate(tag);
    }

    render () {

        let properties = this.state.properties.map((property, idx) => (
            <TagPropertyButton
                key={idx}
                onClick={() => this.setState({editingPropertyIndex: idx})}
                name={property.name}
                value={property.value}
                isEditing={idx === this.state.editingPropertyIndex}
            />
        ));

        let team = undefined;
        const teamProperty = this.state.properties.filter((p) => p.name === "team")[0];
        if (teamProperty !== undefined) {
            team = teamProperty.value; //Ok if undefined
        }

        const editedProperty = this.state.properties[this.state.editingPropertyIndex];
        const editTagProperty = editedProperty === undefined ? (
            <div className="text-center">
                <i>Tag has no properties</i>
            </div>
        ) : (
            <EditTagProperty
                teamFilter={team}
                isOwnGoal={this.state.isOwnGoal}
                lineup={this.props.lineup}
                name={editedProperty.name}
                type={editedProperty.type}
                customOptions={this.props.tagTypes[editedProperty.type].options}
                value={editedProperty.value}
                id={editedProperty.id}
                onChange={this.onChangePropertyValue}
            />
        );

        return (
            <div className="row" style={{height: "100%"}}>
                <div className="col-md-4">
                    <div className="row text-capitalize tag-property-buttons">
                        <div>
                            <OptionPopoverBtn
                                onSelectOption={this.onChangeTag}
                                options={this.props.possibleTagNames}
                                placement="top"
                                columns={2}
                                className="btn btn-lg btn-default btn-darkened fullwidth">
                                <b>{this.props.tag.action}</b>
                            </OptionPopoverBtn>
                        </div>
                        {properties}
                    </div>
                </div>
                <div className="col-md-8">
                    <div className="row">
                        {editTagProperty}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/EditTag.js